import S from './ResumeHeadTitle.module.scss';

interface ResumeHeadTitleProps {
  headTitle: string;
  resumeType: '' | 'write' | 'update' | 'cancel';
  resumeHeadAction: Function;
}

const ResumeHeadTitle = (props: ResumeHeadTitleProps) => {
  const { headTitle, resumeType, resumeHeadAction } = props;
  return (
    <>
      <div className={`${S.head_title_area} wrapper`}>
        <h3 className="h3">{headTitle}</h3>
        {resumeType === 'cancel' ? (
          <>
          <button type="button" className={S.head_btn} onClick={() => resumeHeadAction()}>
              <p className="button-m">돌아가기</p>
          </button>
          </>
        ) : (
          <>
            <button type="button" className={S.head_btn} onClick={() => resumeHeadAction()}>
              {resumeType === 'write' && <p className="button-m">이력서 작성하기</p>}
              {resumeType === 'update' && <p className="button-m">이력서 수정하기</p>}
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default ResumeHeadTitle;
